export default "__VITE_ASSET__cc32d16b__"